import api from "api/config";

//  Login user

export const LoginUserAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/auth/login",
    data,
  });
  return response;
};

// Verify current session/token

export const verifySessionAPI = async () => {
  const response = await api({
    method: "GET",
    url: "/api/v1/auth/verify",
  });
  return response;
};

//  Refresh session (issue new access token)

export const refreshSessionAPI = async () => {
  const response = await api({
    method: "POST",
    url: "/api/v1/auth/refresh",
  });
  return response;
};

// Logout user (invalidate session & clear cookie)

export const logoutAPI = async () => {
  const response = await api({
    method: "POST",
    url: "/api/v1/auth/logout",
  });
  return response;
};

export const ForgotPasswordAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/auth/forgot-password",
    data,
  });

  return response;
};

export const ResetPasswordAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/auth/reset-password",
    data,
  });

  return response;
};
